import React from "react";
import PropTypes from "prop-types";
import Grid from "@mui/material/Grid";

import styles from "./GridContainer.module.scss";

export default function GridContainer({ 
  children, 
  className = "", 
  ...rest 
}) {
  return (
    <Grid container {...rest} className={`${styles.grid} ${className}`.trim()}>
      {children}
    </Grid>
  );
}

GridContainer.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
};